import React from 'react';
import { Button } from '@grubhubprod/gh-cookbook-react';
import { useAuth } from 'src/components/AuthProvider/AuthProvider';

export function SignOutButton(): JSX.Element {
  const { signOut } = useAuth();

  return (
    <Button
      variant="tertiary"
      onClick={signOut}
      className="removeButtonPadding autoButtonHeight"
      buttonSize="small"
    >
      Sign out
    </Button>
  );
}
